import { FunctionComponent } from 'react';
import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';

// Own
import { Field } from './fields';

const ContentUrl: FunctionComponent<Props> = ({ name }) => {
  const { t } = useTranslation('subscription-form');

  return (
    <Form.Item
      label={t('field.contentURL.label')}
      name={name}
      hasFeedback
      rules={[
        { required: true, message: t('field.contentURL.error') as string },
        { type: 'url', message: t('field.contentURL.error') as string },
      ]}
    >
      <Input placeholder={t('field.contentURL.placeholder') as string} />
    </Form.Item>
  );
};

interface Props {
  name: Field;
}

export default ContentUrl;
